import * as Sentry from "@sentry/nextjs";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { useSWRConfig } from "swr";

import { useErrorToaster } from "src/common/components/ErrorDetails";
import { client, endpoint } from "src/lib/bridgeClient";
import { SERVER_COMM_ERROR } from "src/lib/error";

export const deleteWorkflow = async (client: Client, id: string) => {
  return await client(endpoint.deleteWorkflow(encodeURIComponent(id)), "DELETE");
};

export const useDeleteWorkflow = () => {
  const toastError = useErrorToaster();
  const { mutate } = useSWRConfig();

  return async (id: string, name: string): Promise<AxiosResponse> => {
    let response: AxiosResponse;

    try {
      response = await deleteWorkflow(client, id);

      mutate(endpoint.workflows);

      toast.success(`Workflow shut down: ${name}`);
    } catch (error) {
      if (error?.response?.data?.error) {
        toastError("Failed to shut down workflow", error?.response?.data?.error);
      } else {
        toast.error(`Request failed: ${SERVER_COMM_ERROR}`);
        Sentry.captureException(error);
      }

      return error.response;
    }

    return response;
  };
};
